import { preventMarkerSettingsConflictsSaga } from './consistency/preventMarkerSettingsConflicts.saga';
import { removeDeletedRowsLabelOffsetsSaga } from './consistency/removeDeletedRowsLabelOffsets';
import { removeDeletedRowsMarkerImagesSaga } from './consistency/removeDeletedRowsMarkerImages.saga';

export function* mapSettingsMarkersSaga() {
  yield* removeDeletedRowsMarkerImagesSaga();
  yield* removeDeletedRowsLabelOffsetsSaga();
  yield* preventMarkerSettingsConflictsSaga();
}
